import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';

/** A fee amount as stored: the model allows the figure to arrive as a number or a numeric string. */

/** A property's fee, as the fee-setup store hands it out. */

/**
 * A dollar amount with the two decimals money is read in, so $7 and $7.50 are the same shape of
 * number in a list. The figure is coerced because the fee model stores it as either a number or a
 * numeric string.
 */
export const dollarAmount = value => "$".concat(Number(value !== null && value !== void 0 ? value : 0).toFixed(2));

/**
 * How a property's fee reads in the Details panel: a dollar amount, a percentage, or "Not set" when
 * the property has no figure for it.
 *
 * A percentage keeps the figure it was given rather than gaining decimals, since "7.00%" claims a
 * precision nobody entered.
 */
export const feeLabel = fee => {
  if (!(fee !== null && fee !== void 0 && fee.value)) {
    return 'Not set';
  }
  return fee.feeUnitType === FEE_UNIT_TYPES.percentage ? "".concat(fee.value, "%") : dollarAmount(fee.value);
};